const AssetWrapper =() => {

    return(
        <>
            <div className="assetwrapper asset_wrapper_container">
                <div className="asset_wrapper_content">
                    <div className="asset_wrapper_head">
                        
                        <h1>AssetWrapper</h1>
                    </div>
                    <div className="asset_wrapper_body">
                        
                        <h2>body</h2>
                    </div>
                    <div className="asset_wrapper_footer">
                        
                        <h2>footer</h2>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AssetWrapper;